// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"225":"produtoReview","951":"pendencia"}[chunkId] + "." + {"225":"c2ad13a9","951":"ba2c6a5d"}[chunkId] + ".css";
};